<script setup lang="ts">
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import SupportFormModal from './SupportFormModal.vue';
import { SearchResultReasonDocument } from '@schema/directus';

const { open } = useModal({
    component: SupportFormModal,
});
const { result } = useQuery(SearchResultReasonDocument);
</script>

<template>
    <div v-if="result?.SearchResultReason?.length" class="reasons-root">
        <div class="header">پشتیبانی</div>
        <template
            v-for="(reason, index) in result.SearchResultReason"
            :key="reason.id"
        >
            <div class="item" @click="() => open({ reasonId: reason.id })">
                <div class="content">
                    <mr-typography
                        weight="700"
                        color="var(--cool-gray-900)"
                        class="title"
                    >
                        {{ reason.Title }}
                    </mr-typography>
                    <mr-typography
                        color="var(--cool-gray-900)"
                        class="description"
                    >
                        {{ reason.Description }}
                    </mr-typography>
                </div>
                <mr-icon
                    color="var(--blue-400)"
                    size="large"
                    :icon="faChevronLeft"
                />
            </div>
            <mr-divider
                v-if="index !== result.SearchResultReason.length - 1"
                class="mr-divider"
                size="calc(100% - 16px)"
            />
        </template>
    </div>
</template>

<style scoped lang="scss">
.reasons-root {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: white;
    @include shadow;
    .header {
        padding: 16px;
        @include tg-display4($w7, usePalette($p-cool-gray, $p-900));
    }
    .item {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        cursor: pointer;
        .content {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }
    .mr-divider {
        margin: 0 16px;
    }
}
</style>
